import slugify from 'slugify';

const endsWithDashOrSpace = ({ value }) => {
  const lastChar = value.slice(-1); // Get last character
  return lastChar === '-' || lastChar === ' ';
};

const generateSlug = ({ value, allowTrailingDashOrSpace = true }) => {
  const slug = slugify(value, { lower: true, strict: true, trim: true });

  if (allowTrailingDashOrSpace === true && endsWithDashOrSpace({ value })) {
    return `${slug}-`;
  }

  return slug;
};

export default generateSlug;
